import { Box } from '@mui/material';

type LogoProps = {
  src: string;
  alt: string;
};

export const Logo = (props: LogoProps) => {
  return (
    <Box
      component="img"
      sx={{ display: { xs: 'none', md: 'flex' }, ml: 2, mr: 2, height: '24px' }}
      alt={props.alt}
      src={props.src || undefined}
    />
  );
};
